import { RootState } from "../rootStore";

export const selectPatientRegionsList = ({ patientRegions }: RootState) =>
  patientRegions.patientRegionsList;

export const selectSortConfig = ({ patientRegions }: RootState) =>
  patientRegions.sortConfig;

export const selectLoading = ({ patientRegions }: RootState) =>
  patientRegions.loading;

export const selectHasMoreItems = ({ patientRegions }: RootState) =>
  patientRegions.total > patientRegions.offset + patientRegions.limit;

export const selectJoints = ({ patientRegions }: RootState) =>
  patientRegions.joints;
export const selectInitialRegionFilterParams = ({
  patientRegions,
}: RootState) => patientRegions.jointFilterParams;

export const selectJointFilterParams = ({ patientRegions }: RootState) =>
  patientRegions.jointFilterParams;
